import React, { createContext, useContext } from 'react';
import { invariant } from '../../utils/invariant';
import { useApplication } from './ApplicationContext';
const SettingContext = createContext(null);
export const SettingContextProvider = ({ settings, children, }) => {
    return (<SettingContext.Provider value={settings}>
      {children}
    </SettingContext.Provider>);
};
export function useSettings() {
    const settings = useContext(SettingContext);
    invariant(settings, 'Settings is not provide');
    return settings;
}
/**
 * Hook to get payment methods from both root level and defaultValues
 * Root level takes precedence over defaultValues
 */
export function usePaymentMethods() {
    var _a;
    const settings = useSettings();
    // Root level paymentMethods takes precedence
    if (settings.paymentMethods && settings.paymentMethods.length > 0) {
        return settings.paymentMethods;
    }
    // Fallback to defaultValues.paymentMethods
    if (((_a = settings.defaultValues) === null || _a === void 0 ? void 0 : _a.paymentMethods) && settings.defaultValues.paymentMethods.length > 0) {
        return settings.defaultValues.paymentMethods;
    }
    // Return undefined if neither is set
    return undefined;
}
export function getNonEditableDefaultValue(v) {
    return v && v.value && v.editable === false ? v.value : undefined;
}
export function useNFT() {
    const { orderFacade: { NFTInfo }, } = useApplication();
    return NFTInfo || null;
}
